import { render, staticRenderFns } from "./DailyOpenedAndClosedViolations.vue?vue&type=template&id=0f78d4a4&scoped=true&"
import script from "./DailyOpenedAndClosedViolations.vue?vue&type=script&lang=js&"
export * from "./DailyOpenedAndClosedViolations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78d4a4",
  null
  
)

export default component.exports